import CampaignsDialogControl from "./CampaignsDialogControl";

export default CampaignsDialogControl;
